<template>
  <div class="container">
    <nav class="navbar navbar-fixed-top" role="navigation">
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#top-navbar-1"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link class="navbar-brand" to="/">EMAP</router-link>
        </div>
      </div>
    </nav>
    <!-- form para inserir nova senha -->
    <div class="row">
      <br />
      <div class="col-md-4 col-md-offset-4">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div v-if="msg">
          <div class="alert" v-bind:class="[msgAlert ? 'alert-info': 'alert-danger']">
            <span><i class="fa fa-exclamation fa-fw"></i><strong>{{msg}}</strong></span>
          </div>
        </div>
        <div v-if="bool" class="login-panel panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Insira a nova senha</h3>
          </div>
          <div class="panel-body">
            <form role="form" @submit.prevent="confirmPassword()">
              <fieldset>
                <div class="form-group">
                  <input
                    class="form-control"
                    placeholder=" Nova Senha"
                    name="senha"
                    type="password"
                    autofocus
                    v-model="user.senha"
                    required
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control"
                    placeholder="Confirmar Senha"
                    name="confirm-senha"
                    type="password"
                    autofocus
                    v-model="user.confirmSenha"
                    required
                  />
                </div>
                <!-- Change this to a button or input when using this as a form -->
                <button type="submit" class="btn btn-lg btn-info btn-block">
                  Enviar
                </button>
              </fieldset>
            </form>
          </div>
        </div>
        <div v-else class="login-panel panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">
              Informe o email que deseja recuperar a senha
            </h3>
          </div>
          <div class="panel-body">
            <form role="form" @submit.prevent="recover()">
              <fieldset>
                <div class="form-group">
                  <input
                    class="form-control"
                    placeholder="E-mail"
                    type="email"
                    autofocus
                    v-model="user.email"
                    required
                  />
                  <p v-if="!validarEmail && user.email !==''" style="color: red;">
                    <i class="fa fa-exclamation fa-fw"></i>E-mail inválido
                  </p>
                </div>
                <!-- Change this to a button or input when using this as a form -->
                <button type="submit" class="btn btn-lg btn-info btn-block">
                  Enviar
                </button>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
      <div class="container">
        <!-- Main component for a primary marketing message or call to action -->
        <div class="col-md-4 col-md-offset-4">
          <p class="text-center">
            EMAP. Empresa Maranhense de Administração Portuária.
          </p>
          <p class="text-center">Todos os direitos reservados 2021</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RecoverPass",
  inject: ["loading"],
  data() {
    return {
      user: {email: "", senha: "", confirmSenha: ""},
      bool: false,
      msg: null,
      msgAlert: false,
    };
  },
  mounted(){

     this.bool = this.$route.query.bool

  },
  computed:{
    validarEmail() {
      const re = /\S+@\S+\.\S+/
      return re.test(this.user.email)
    }
  },
  methods: {
    recover(){
      this.loading.value = true;

      this.$http.post(`/user/enviarToken?email=${this.user.email}`)
        .then( response => {
          console.log(response)
          this.msgAlert = true;
          this.user.email = ""
          this.msg ='verifique seu email'
        } )
        .catch(error => {
          console.log(error)
          this.msgAlert = false;
          this.msg = 'o email informado não está registrado!'
        })
        .finally(()=> this.loading.value = false )
    },
    confirmPassword(){
      if(this.user.confirmSenha === this.user.senha){
        this.loading.value = true;
        const token = this.$route.query.token
        this.$http.post(`/user/recover-password?token=${token}&password=${this.user.senha}`)
          .then(response => {
            this.user.senha = "";
            this.user.confirmSenha = "";
            this.msg ='sua senha foi alerada com sucesso'
            this.$router.push('/login')

          })
          .catch(error => console.log(error))
          .finally( () => setTimeout(() => this.loading.value = false, 300))


      }else{
        this.msg ='as senhas não conferem'
      }
    }
  },
};
</script>
<style scoped>
.navbar {
  margin-bottom: 0;
  background: #333;
  background: rgba(51, 51, 51, 0.8);
  border: 0;
  -moz-border-radius: 0;
  -webkit-border-radius: 0;
  border-radius: 0;
}

.navbar-brand {
  width: 125px;
  height: 66px;
  text-indent: -99999px;
  background: url(../../assets/img/logo.png) left center no-repeat;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/RecoverPass.vue